import clsx from "clsx";
import React from "react";
import { RichText, RichTextProps } from "web/react/emo/rich-text/rich-text";
import * as styles from "./feature-article-rich-text.css";

interface FeatureArticleRichTextProps extends Omit<RichTextProps, "textStyle"> {
    children: string;
    className?: string;
    textStyle?: RichTextProps["textStyle"];
}

/**
 * The emo `RichText` with Feature Article markdown styling
 */
export function FeatureArticleRichText({
    children,
    className,
    textStyle = "body",
    ...props
}: FeatureArticleRichTextProps): React.ReactElement {
    return (
        <RichText
            className={clsx(className, styles.richText)}
            textStyle={textStyle}
            color="secondary"
            {...props}
        >
            {children}
        </RichText>
    );
}
